import React from "react";
import { CircleHelp, ExternalLink } from "lucide-react";

/** "Need Help?" card from Settings; the button opens an exchange's connect guide. */
export const NeedHelpCard: React.FC<{ onViewGuide: () => void }> = ({ onViewGuide }) => (
  <div className="glass flex flex-col gap-6 !rounded-2xl p-4">
    <div className="flex items-start gap-3">
      <span className="flex size-12 shrink-0 items-center justify-center rounded-full border border-[#2dcc89]/60 bg-[#07a66c]/10">
        <CircleHelp className="size-6 text-[#2dcc89]" />
      </span>
      <div className="flex flex-col gap-1">
        <p className="text-base font-semibold leading-6 text-white">Need Help?</p>
        <p className="text-xs leading-[18px] text-[#d4d4d4]">
          Follow our guide to connect your exchange accounts safely and securely.
        </p>
      </div>
    </div>
    <button
      type="button"
      onClick={onViewGuide}
      className="flex h-10 items-center justify-center gap-2 rounded-xl border border-[#2dcc89] bg-[#07a66c]/10 text-sm font-semibold text-[#2dcc89] transition-colors hover:bg-[#07a66c]/20"
    >
      View Guide
      <ExternalLink className="size-5" />
    </button>
  </div>
);
